import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7a5d2ddf0b44001419d09c_1786736212702_3456232e/babyreveal/src/app/event-setup/components/EventSetupClient.tsx");
